// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"abd36b29","456":"96f75e2b","753":"e1a27014","833":"f2031e6b"}[chunkId] + ".chunk.js";
};